function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.72C4.28865 14.72 1.28 11.7114 1.28 8C1.28 4.28865 4.28865 1.28 8 1.28C11.7114 1.28 14.72 4.28865 14.72 8C14.72 11.7114 11.7114 14.72 8 14.72ZM11.5355 5.01699C11.8248 4.72767 12.2938 4.72767 12.5831 5.01699H12.583C12.8723 5.30629 12.8723 5.77535 12.583 6.06467L7.34528 11.3031C7.06397 11.5844 6.61279 11.5921 6.32211 11.3262C6.31417 11.3191 6.30605 11.3114 6.29772 11.3031L3.41696 8.42194C3.12768 8.13265 3.12769 7.66358 3.41696 7.37427C3.70622 7.08495 4.17523 7.08495 4.46451 7.37427L6.82151 9.73155L11.5355 5.01699Z",
  fill: "#469650"
});

const SvgCheck = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check.10bbf963.svg";
export { ForwardRef as ReactComponent };